export enum LoginErrorReason {
  WrongCredentials = 'wrong_credentials',
  TooManyAttempts = 'too_many_attempts',
  Other = 'other',
}

export interface LoginErrorResponse {
  message?: string | string[];
  retry_after?: number;
}

const UNAUTHORIZED = 401;
const TOO_MANY_REQUESTS = 429;
const DEFAULT_MESSAGE = 'No se pudo iniciar sesión. Inténtalo nuevamente.';

const reasonOf = (status: number): LoginErrorReason => {
  if (status === UNAUTHORIZED) return LoginErrorReason.WrongCredentials;
  if (status === TOO_MANY_REQUESTS) return LoginErrorReason.TooManyAttempts;
  return LoginErrorReason.Other;
};

const messageOf = (message: LoginErrorResponse['message']): string => {
  if (Array.isArray(message)) return message.join(' ');
  return message || DEFAULT_MESSAGE;
};

export class LoginError extends Error {
  public readonly reason: LoginErrorReason;

  public readonly retryAfterSeconds: number;

  public constructor(status: number, { message, retry_after: retryAfter }: LoginErrorResponse) {
    super(messageOf(message));
    this.reason = reasonOf(status);
    this.retryAfterSeconds = Number(retryAfter ?? 0);
    Object.setPrototypeOf(this, LoginError.prototype);
  }
}
